var calculator = function(weekly, agentFee){
	// only integers or out you go
	if(weekly !== parseInt(weekly, 10)) { return null }
	if(agentFee !== parseInt(agentFee, 10)) { return null }
	var cubbi = weekly * 0.02 * 52 + 199;
	var agent = weekly * (agentFee/100) * 52 + (weekly * 2) + 200 + 108;
	var savings = (agent - cubbi);
	var saved = (savings / agent) * 100;
	return { cubbi: cubbi, agent: agent, savings: savings, saved: saved }
};

var format = function(number) {
	return number.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,').split('.')[0];
};

var buyObject = function(amount) {
	amount = amount * 1;
	switch(true) {
		case (amount < 500):
			return "buy a new Apple watch";
			break;
		case (amount < 1000):
			return "buy a new 50inch TV";
			break;
		case (amount < 1500):
			return "buy a new laptop";
			break;
		case (amount < 2000):
			return "buy a home entertainment system";
			break;
		case (amount < 2500):
			return "go on a holiday to New Zealand";
			break;
		case (amount < 3500):
			return "buy a full set of kitchen appliances";
			break;
		case (amount < 5000):
			return "buy a new scooter";
			break;
		case (amount < 7000):
			return "go on family holiday to Hawaii";
			break;
		case (amount < 10000):
			return "Paint and re-carpet your entire home";
			break;			
		default:
			return "buy a new kitchen";
		break;
	}
}

$(document).ready(function() {
	$('.rent-input').keyup(function(e){
     calc();
	});

  $('.agent-fee-input').keyup(function(e){
    calc();
  });

	function calc() {
    var weekly = parseInt($('#rent-amount').val().replace(/[^0-9]/g, ''), 10);
    var agentFee = parseInt($('#agent-fee').val().replace(/[^0-9]/g, ''), 10);
    var result = calculator(weekly, agentFee);
    if (result === null) { return };
    $('.savings-result').text("$"+format(result.savings));
    $('.agent-result').text("$"+format(result.agent));
    $('.cubbi-result').text("$"+format(result.cubbi));
    $('.saved-result').text(""+format(result.saved));
    $('.agent-fee-print').text(format(agentFee)+"%");
    $('.save-object').text(buyObject(result.savings));
  }

	$('.rent-input input').trigger('keyup');

	$('.show-all').click(function(e){
        var elem = $(this);
        $(elem.attr('data-target-panel') ).show();
        return false;
	});
});